import config from '@/config';
import { PLATFORMS } from '../constants/game';
import { AW_COOKIE, GEOLOCATION_COOKIES } from '../constants/metadata';
import getQueryParams from './getQueryParams';
import Cookie from 'js-cookie';
import { Region } from '@/store/slices/session/types';
import { normalizeRegion } from '../constants/regions';
import { getPlatform } from './gameContextGetters';

export const getGeolocationCookieName = (): string =>
  getPlatform() === PLATFORMS.XSELL
    ? GEOLOCATION_COOKIES.XSELL_GEOLOCATION_TOKEN
    : GEOLOCATION_COOKIES.X_GEOLOCATION_TOKEN;

export const getGeocomplyCookie = () =>
  Cookie.get(getGeolocationCookieName()) ?? '';

export const getRegion = (): Lowercase<Region> => {
  let returnString: Lowercase<Region> | undefined;
  const rawRegion = getQueryParams('region');
  const region = normalizeRegion(rawRegion);
  const cookieRegion =
    normalizeRegion(Cookie.get(AW_COOKIE.SBK_REGION)) ??
    normalizeRegion(Cookie.get(AW_COOKIE.REGION));

  if (region && rawRegion) {
    // Check if the query parameter is present in the URL - long link
    returnString = region === cookieRegion ? region : cookieRegion || region;
  } else {
    // Check if the cookie is present - short link
    returnString = cookieRegion;
  }

  const defaultRegion = normalizeRegion(config.defaultRegion);

  // If the region is not found in the cookie or query parameter, use the default region from the config
  return (returnString ?? defaultRegion) as Lowercase<Region>;
};

export const getCookieValue = (cookieName: string, shouldDecode = true) => {
  if (typeof document === 'undefined') {
    return '';
  }

  const cookie = (document.cookie || '')
    .split(';')
    .map((item) => item.trim())
    .find((item) => cookieName === item.split('=')[0]);

  if (cookie) {
    const cValue: string = cookie.split('=')[1] || '';
    return shouldDecode ? decodeURIComponent(cValue) : cValue;
  }

  return '';
};
